import React from 'react'
import dividerImage from '../../assets/images/divider.svg';

const Divider = (props) => 
    <img className={`divider ${props.small ? 'small': ''}`} src={dividerImage} />

export default Divider;


// WEBPACK FOOTER //
// ./components/Controls/Divider.js